export default "__VITE_ASSET__DV$zOb_n__"